import Shape from "./Shape";

class Diagram {
    constructor() {
        this.shapes = [];
        this.ids = {};
        this.index = 0;
        this.text = "Main";
        this.identifier = 0;

        this.tab_size = 4;
    }

    get_new_id(line) {
        const ids = this.ids;

        if (ids[line] !== undefined) {
            return ids[line];
        }

        this.identifier += 1;
        ids[line] = this.identifier;
        return this.identifier;
    }

    add_child(child) {
        this.shapes.push(child);
    }

    add_branch(name) {
        console.log(name);
        this.invalid_syntax();
    }

    parse(contents) {
        const lines = contents.split("\n");

        let is_new_branch;
        let is_prev_branch;
        let is_current_branch;


        let shape;
        let stripped;
        let line;

        let prev_item = this;
        let current_branch = this;
        let prev_index = 0;
        let prev_direction = "";
        const stack = [];

        let direction;
        let branch_name = null;

        for (line of lines) {
            stripped = this.strip(line);
            let index;
            if (!stripped) {
                continue;
            }

            [line, index] = this.identify_index(line);

            is_new_branch = index > prev_index;
            is_prev_branch = index < prev_index;
            is_current_branch = index === prev_index;


            if (line[0] === "[") {
                [branch_name, direction] = this.parse_branch_details(line);
            } else {
                [branch_name, direction] = ["", ""];
            }

            if (is_new_branch) {
                if (!branch_name) {
                    this.invalid_syntax();
                }

                if (index - prev_index > 1) {
                    this.invalid_syntax();
                }

                if (prev_item === null) {
                    this.invalid_syntax();
                }

                stack.push(current_branch);

                current_branch = prev_item;
                prev_index = index;
                current_branch.add_branch(branch_name);
            }

            if (is_prev_branch) {
                let i = index;
                while (i < prev_index) {
                    current_branch = stack.pop();
                    i += 1;
                }

                if (branch_name) {
                    current_branch.add_branch(branch_name);
                }
            }

            if (is_current_branch) {
                if (branch_name) {
                    current_branch.add_branch(branch_name);
                }
            }

            if (!branch_name) {
                [shape, direction] = this.parse_line(line, index, prev_direction);

                current_branch.add_child(shape);
                prev_item = shape;
            }

            prev_index = index;
            prev_direction = direction;

        }

    }

    parse_line(line, position, prev_direction) {
        if (line[0] !== "#") {
            this.invalid_syntax();
        }

        let shape_end_index = this.find_shape_end_index(line);
        let shape_type = line.substr(1, shape_end_index - 1);

        let text_start_index = line.indexOf(":");
        if (text_start_index < 0) {
            this.invalid_syntax();
        }
        let text = line.substr(text_start_index + 1);
        let cmds = line.substr(0, text_start_index);

        let shape = new Shape(shape_type, text, position);
        shape.direction = prev_direction;
        shape.identifier = this.get_new_id(line);
        shape.style = this.find_style(cmds);
        return [shape, this.find_direction(cmds)];
    }

    parse_branch_details(line) {
        const index = line.indexOf("]");
        const branch_name = line.substr(1, index - 1);
        const direction = this.find_direction(line, index);

        return [branch_name, direction];
    }

    find_shape_end_index(line) {
        const chars = [" ", ":", "<", "{"];
        let i = 0;
        while (i < line.length) {
            let char = line[i];
            if (chars.indexOf(char) >= 0) {
                return i;
            }
            i += 1;
        }

        return -1;
    }

    find_style(line, index = 0) {
        return this.find_enclosed(line, index, "{", "}");
    }

    find_direction(line, index = 0) {
        return this.find_enclosed(line, index, "<", ">");
    }

    find_enclosed(line, index, start_symbol, close_symbol) {
        let direction = "";
        index = line.indexOf(start_symbol, index + 1);
        if (index > 0) {
            index += 1;
            let close_index = line.indexOf(close_symbol, index);

            if (close_index < 0)
                this.invalid_syntax();

            direction = line.substr(index, close_index - index);
        }
        return direction;
    }

    invalid_syntax() {
        throw new Error("Invalid Syntax");
    }

    identify_index(line) {
        const size = this.tab_size;
        const new_line = [];

        line.split("").forEach(function (char) {
            if (char === "\t") {
                let i = 0;
                while (i < size) {
                    new_line.push(" ");
                    i += 1;
                }
            } else {
                new_line.push(char);
            }
        });


        const new_line_str = new_line.join("");
        let count = 0;

        new_line_str.split("").every(function (char) {
            if (char === " ") {
                count += 1;
                return true;
            } else {
                return false;
            }
        });


        if (count === 0) {
            return [this.strip(new_line_str), count];
        }

        if (count % size !== 0) {
            throw new Error("Invalid Syntax.");
        }

        return [new_line_str.substr(count), count / size];
    }

    strip(line) {
        return line.replace(/^\s+|\s+$/g, '');
    }


    json() {
        const children = [];
        let shape;
        for (shape of this.shapes) {
            children.push(shape.json());
        }

        return {
            children
        };
    }

    process() {
        const shapes = this.shapes;
        shapes.every(function (shape, index) {
            console.log(shape.text, index);
            shape.process();
            if (index > 0) {
                const prev_item = shapes[index - 1];
                shape.set_prev_item(prev_item);
            }

            return true;
        });
    }

    print_ids(generator) {
        let shape;
        for (shape of this.shapes) {
            shape.print_id(generator);
        }
    }

    print_connections(generator) {
        let shape;
        for (shape of this.shapes) {
            shape.print_connection(generator);
        }
    }

}

export default Diagram;
